(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-finder-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuiz(root) {
    if (root.dataset.pfqBound) return;
    root.dataset.pfqBound = '1';

    var selected = { '1': [], '2': [] }; // each step holds a list of chosen tags (multi-select)
    var grid = root.querySelector('[data-grid]');
    var hint = root.querySelector('[data-hint]');
    var empty = root.querySelector('[data-empty]');
    var moreBtn = root.querySelector('[data-more]');
    var countEl = root.querySelector('[data-count]');
    var panel3 = root.querySelector('[data-panel="3"]');
    var title3 = panel3 ? panel3.querySelector('.pfq__question') : null;
    var perPage = parseInt(grid && grid.getAttribute('data-per-page'), 10) || 12;
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.pfq__card')) : [];
    var matched = [], shown = 0;
    var loadingEl = root.querySelector('[data-loading]');
    var totalPages = parseInt(root.getAttribute('data-total-pages') || '1', 10);
    var canFetch = (typeof window.fetch === 'function' && typeof window.DOMParser === 'function');
    // false while pages 2..N are still being fetched; filter() holds results until true.
    var productsLoaded = !(totalPages > 1 && canFetch && grid);

    // Filter dimension: 'tags' (default) matches product tags on both steps;
    // 'type_flavour' matches a product tag on step 1 and the custom.flavour
    // metafield on step 2 (used by the e-liquid finder landing page).
    var matchMode = root.getAttribute('data-match-mode') || 'tags';
    function parseCard(card) {
      try { card._tags = JSON.parse(card.getAttribute('data-tags') || '[]'); }
      catch (e) { card._tags = []; }
      card._type = (card.getAttribute('data-product-type') || '').trim();
      try {
        var f = JSON.parse(card.getAttribute('data-flavour') || '[]');
        if (f == null) f = []; // empty metafield → JSON null; treat as no flavour
        card._flavours = (Array.isArray(f) ? f : [f])
          .map(function (x) { return String(x).trim(); })
          .filter(function (x) { return x.length; });
      } catch (e) { card._flavours = []; }
    }
    cards.forEach(parseCard);

    root.querySelectorAll('.pfq__options').forEach(function (group) {
      var g = group.getAttribute('data-group');
      group.querySelectorAll('.pfq__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tag = btn.getAttribute('data-tag') || '';
          var arr = selected[g];
          var already = arr.indexOf(tag) !== -1;
          // Single-select per question: clear this group's current choice and
          // deselect every option in the group first.
          arr.length = 0;
          group.querySelectorAll('.pfq__option').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          // Select the clicked one; clicking the already-active option clears it (toggle off).
          if (!already) {
            arr.push(tag);
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
          }
          updateSteps();
          filter();
        });
      });
    });

    if (moreBtn) moreBtn.addEventListener('click', reveal);

    function updateSteps() {
      var s1 = selected['1'].length > 0;
      var s2 = selected['2'].length > 0;
      root.querySelectorAll('.pfq__step').forEach(function (step) {
        var n = step.getAttribute('data-stepnum');
        step.classList.remove('is-active', 'is-done');
        if (n === '1') { s1 ? step.classList.add('is-done') : step.classList.add('is-active'); }
        else if (n === '2') { s2 ? step.classList.add('is-done') : (s1 ? step.classList.add('is-active') : null); }
        else if (n === '3') { if (s1 && s2) step.classList.add('is-active'); }
      });
    }

    function stepMatches(card, vals, stepNum) {
      // No selection in this step = no constraint.
      if (!vals.length) return true;
      // Pick which product field this step filters on.
      var hay;
      if (matchMode === 'type_flavour') {
        hay = (stepNum === '1') ? card._tags : card._flavours;
      } else {
        hay = card._tags;
      }
      // Within a step: AND — the product must satisfy EVERY chosen value.
      // A blank value (e.g. "Not sure") is treated as "no preference".
      for (var i = 0; i < vals.length; i++) {
        if (vals[i] !== '' && hay.indexOf(vals[i]) === -1) return false;
      }
      return true;
    }

    function filter() {
      // While the rest of the catalogue is still loading, hold the results so
      // the finder never shows a partial set. The loading bar gives feedback;
      // the selector + green states stay fully interactive underneath.
      if (!productsLoaded) {
        if (panel3) panel3.hidden = true;
        return;
      }
      var s1 = selected['1'], s2 = selected['2'];
      var anySelected = s1.length > 0 || s2.length > 0;
      cards.forEach(function (c) { c.hidden = true; });
      shown = 0;
      if (hint) hint.hidden = true;

      // Nothing selected → hide the whole "We recommend" section.
      if (!anySelected) {
        matched = [];
        if (panel3) panel3.hidden = true;
        if (title3) title3.hidden = false;
        if (empty) empty.hidden = true;
        if (moreBtn) moreBtn.hidden = true;
        if (countEl) countEl.hidden = true;
        return;
      }

      // Across steps: AND — the product must satisfy each answered step.
      matched = cards.filter(function (card) {
        return stepMatches(card, s1, '1') && stepMatches(card, s2, '2');
      });
      if (panel3) panel3.hidden = false; // section stays visible once a choice is made

      if (matched.length === 0) {
        // No match: hide the "We recommend" title + Load more, show the message.
        if (title3) title3.hidden = true;
        if (empty) empty.hidden = false;
        if (moreBtn) moreBtn.hidden = true;
        if (countEl) countEl.hidden = true;
        return;
      }

      // Has matches: show the title, hide the message, reveal products.
      if (title3) title3.hidden = false;
      if (empty) empty.hidden = true;
      reveal();
    }

    function reveal() {
      var next = matched.slice(shown, shown + perPage);
      next.forEach(function (c) { c.hidden = false; });
      shown += next.length;
      if (moreBtn) moreBtn.hidden = shown >= matched.length;
      if (countEl) {
        countEl.hidden = matched.length === 0;
        countEl.textContent = 'Showing ' + shown + ' of ' + matched.length;
      }
    }

    function autoSelectFromURL() {
      // Deep-link from the e-liquid mega-menu finder: ?pfq1=<device>&pfq2=<flavour>.
      // Paints the matching options green right away, before products finish loading.
      try {
        var qp = new URLSearchParams(window.location.search);
        ['1', '2'].forEach(function (g) {
          var want = (qp.get('pfq' + g) || '').trim().toLowerCase();
          if (!want) return;
          var grp = root.querySelector('.pfq__options[data-group="' + g + '"]');
          if (!grp) return;
          var hit = null;
          grp.querySelectorAll('.pfq__option').forEach(function (b) {
            if ((b.getAttribute('data-tag') || '').toLowerCase() === want) hit = b;
          });
          if (hit) hit.click();
        });
      } catch (e) {}
    }

    // Order: (1) selector is already interactive; (2) show the loading bar and
    // auto-select the deep-linked options (green) immediately; (3) pull pages
    // 2..N; (4) once the whole catalogue is in, hide the bar and reveal results.
    if (loadingEl && !productsLoaded) loadingEl.hidden = false;
    filter();            // holds results while loading; hides panel3 when 1 page + no selection
    autoSelectFromURL(); // green immediately, even before products finish loading

    (function loadRemainingPages() {
      if (productsLoaded) return; // 1 page (<=250) or no fetch → already fully loaded
      var pending = totalPages - 1, done = false;
      function settle() {
        if (done) return;
        if (--pending <= 0) {
          done = true;
          productsLoaded = true;
          if (loadingEl) loadingEl.hidden = true;
          filter(); // reveal the real, complete results now
        }
      }
      for (var p = 2; p <= totalPages; p++) {
        (function (page) {
          var u;
          try { u = new URL(window.location.href); } catch (e) { u = null; }
          if (!u) { settle(); return; }
          u.searchParams.set('page', page);
          fetch(u.toString(), { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              doc.querySelectorAll('[data-pfq] .pfq__card').forEach(function (c) {
                var node = document.importNode(c, true);
                node.hidden = true;
                grid.appendChild(node);
                parseCard(node);
                cards.push(node);
              });
            })
            .catch(function () {})
            .then(settle);
        })(p);
      }
    })();
  }

  function boot() { document.querySelectorAll('[data-pfq]').forEach(initQuiz); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pfq]');
    if (el) initQuiz(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
